// removed by extract-text-webpack-plugin
module.exports = {"root":"UpgradePackage__root___19Lyp","button":"UpgradePackage__button___lJVd_","button_active":"UpgradePackage__button_active___2Kvqp"};